import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Adds all `}<a parentName="p" {...{
          "href": "/api/../api/projects/shoppingLists#lineitem"
        }}>{`LineItems`}</a>{` of a `}<a parentName="p" {...{
          "href": "/api/../api/projects/shoppingLists#shoppinglist"
        }}>{`ShoppingList`}</a>{` to the cart.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"addShoppingList"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`shoppingList`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#resourceidentifier"
          }}>{`ResourceIdentifier`}</a>{` of a `}<a parentName="li" {...{
            "href": "/api/../api/projects/shoppingLists#shoppinglist"
          }}>{`ShoppingList`}</a></li>
        <li parentName="ul"><inlineCode parentName="li">{`supplyChannel`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#resourceidentifier"
          }}>{`ResourceIdentifier`}</a>{` of a `}<a parentName="li" {...{
            "href": "/api/../api/projects/channels#channel"
          }}>{`Channel`}</a>{` - Optional`}<br parentName="li"></br>
          {`If present a `}<a parentName="li" {...{
            "href": "/api/../api/types#reference"
          }}>{`Reference`}</a>{` to the channel will be set for all `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#lineitem"
          }}>{`LineItems`}</a>{` that are added to the cart.`}<br parentName="li"></br>
          {`The channel must have the `}<inlineCode parentName="li">{`InventorySupply`}</inlineCode>{` `}<a parentName="li" {...{
            "href": "/api/../api/projects/channels#channelroleenum"
          }}>{`channelRoleEnum`}</a>{`.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`distributionChannel`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#resourceidentifier"
          }}>{`ResourceIdentifier`}</a>{` of a `}<a parentName="li" {...{
            "href": "/api/../api/projects/channels#channel"
          }}>{`Channel`}</a>{` - Optional`}<br parentName="li"></br>
          {`If present a `}<a parentName="li" {...{
            "href": "/api/../api/types#reference"
          }}>{`Reference`}</a>{` to the channel will be set for all `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#lineitem"
          }}>{`LineItems`}</a>{` that are added to the cart.`}<br parentName="li"></br>
          {`The Channel must have the `}<inlineCode parentName="li">{`ProductDistribution`}</inlineCode>{` `}<a parentName="li" {...{
            "href": "/api/../api/projects/channels#channelroleenum"
          }}>{`ChannelRoleEnum`}</a></li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      